import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
import { deletePermission } from 'src/store/loan'

import { deleteLoanPermissionModalName } from '../../constants'
import { AppDispatch } from 'src/store/index.d'
import { translateBase } from '../../helpers'

const deleteLoanPermissionFetcher = 'delete-loan-permission-fetcher'

const DeleteLoanPermissionModal: FC<{ onRefresh: () => void }> = ({ onRefresh }) => {
  const dispatch = useDispatch<AppDispatch>()

  function handleConfirm({ permissionID, ID, hash }: { permissionID: number; ID: string; hash: string }) {
    // dispatch(
    //   fetchSFM({
    //     instanceName: deleteLoanPermissionFetcher,
    //     callApi: Loan.deletePermission,
    //     callApiArgs: [permissionID, ID, hash],
    //     resolve: onRefresh,
    //   }),
    // )

    //UPDATED API REQUEST loan_oper_api page:accesspermdelete
    dispatch(
      deletePermission({
        LoanID: ID,
        HashSum_LoanID_: hash,
        ID: permissionID,
      }),
    ).then((response) => {
      if (!deletePermission.fulfilled.match(response)) {
        dispatch(LKModalActions.openInfo(translateBase(response.payload as string)))
        return
      }
      onRefresh()
    })
  }

  return <LKModal.Confirmation name={deleteLoanPermissionModalName} onConfirm={handleConfirm} />
}

export const openDeleteLoanPermissionModal = (permissionID: number, ID: string, hash: string) =>
  LKModalActions.openConfirmation(deleteLoanPermissionModalName, {
    permissionID,
    ID,
    hash,
  })

export default DeleteLoanPermissionModal
